<template>
	<div class="columns is-gapless is-marginless is-centered">
		<div class="column is-narrow">
			<section class="is-auth-panel">
				<app-logo />
				<router-view />
			</section>
		</div>
		<div class="column is-hidden-touch">
			<section class="hero is-light is-fullheight is-bold">
				<div class="hero-body dailydata-homepage"></div>
			</section>
		</div>
	</div>
</template>

<script>
export default {
	name: "AuthenticationLayout"
};
</script>

<style lang="scss">
.dailydata-homepage {
	background-image: url("https://dailycare.imgix.net/Respite.jpg?fm=webp");
	background-size: cover;
	background-position: 50% 50%;
}

.is-auth-panel {
	padding: 1.5rem;

	@include tablet {
		width: 400px;
		margin: 0 auto;
	}

	@include desktop() {
		flex: none;
		padding: 2rem;
	}
	@include widescreen() {
		width: 500px;
		padding: 3.5rem 2.5rem;
	}
}
</style>
